import React from "react";
import { useHistory } from "react-router-dom";

function AuthMail() {
  const history = useHistory();
  
  return (
    <div className="auth-mail font-bold">
      <div className="auth-form">
        <h3>이메일 인증이 필요합니다.</h3>
        <section className="txt-center txt-dark-gray mt-5">
          <p className="font-medium mb-5">
            가입하신 이메일로 인증 메일이 전송되었습니다. <br />
            이메일의 인증 버튼을 클릭하면 회원가입이 완료됩니다.
          </p>
          <button
            className="btn-blue-md mb-2 font-bold width-20 mt-3"
            onClick={() => history.push("/")}
          >
            홈으로
          </button>
          <p className="mt-5">
            이메일을 확인할 수 없나요?
            <br />
            이메일을 받지 못하신 경우 스팸 편지함을 확인해 주세요.
          </p>
        </section>
      </div>
    </div>
  );
}

export default AuthMail;
